/**
 * Maps Firebase Auth error codes to user-friendly messages
 */
const AUTH_ERROR_MESSAGES = {
  'auth/user-not-found': 'No account found with this email',
  'auth/wrong-password': 'Incorrect password',
  'auth/invalid-credential': 'Invalid email or password',
  'auth/invalid-login-credentials': 'Invalid email or password',
  'auth/email-already-in-use': 'An account with this email already exists',
  'auth/weak-password': 'Password must be at least 6 characters',
  'auth/invalid-email': 'Please enter a valid email address',
  'auth/too-many-requests': 'Too many attempts. Please try again later',
  'auth/popup-closed-by-user': 'Sign-in cancelled',
  'auth/cancelled-popup-request': 'Sign-in cancelled',
  'auth/popup-blocked': 'Pop-up blocked. Please allow pop-ups for this site',
  'auth/network-request-failed': 'Network error. Please check your connection',
  'auth/requires-recent-login': 'Please sign in again to continue',
  'auth/user-disabled': 'This account has been disabled',
  'auth/operation-not-allowed': 'This sign-in method is not enabled',
  'auth/account-exists-with-different-credential': 'An account already exists with this email using a different sign-in method',
};

export const getAuthErrorMessage = (error) => {
  if (!error) return 'An error occurred. Please try again';
  
  // Check if it's a Firebase error with a code
  if (error.code && AUTH_ERROR_MESSAGES[error.code]) {
    return AUTH_ERROR_MESSAGES[error.code];
  }
  
  // Fallback: try to clean up the message
  if (error.message) {
    // Remove "Firebase: " prefix and error code suffix
    let msg = error.message
      .replace('Firebase: ', '')
      .replace(/\s*\(auth\/[^)]+\)\.?$/, '')
      .trim();
    
    // If we still have a reasonable message, use it
    if (msg && msg.length > 0 && msg.length < 100) {
      return msg;
    }
  }
  
  return 'An error occurred. Please try again';
};
